function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import text from '../../../text';
import OutlinedText from '../../text/OutlinedText';
import { MAP_ZOOM_LEVEL_TO_HIDE_ELEMENTS } from '../constants';
import { MapViewContext } from '../mapViewContext';
import DrawingControlsButton from './drawingControlsButton';
var rectangleIcon = '/public/img/rectangle-tool.svg';
var polygonIcon = '/public/img/polygon-tool.svg';
var polylineIcon = '/public/img/polyline-tool.svg';
var booleanIcon = '/public/img/boolean-tool.svg';
var undoIcon = '/public/img/undo-tool.svg';
var redoIcon = '/public/img/redo-tool.svg';
export var DRAWING_CONTROLS_ID = 'drawing-controls';
export var MAP_STATES = {
    DRAWING_POLYGON: 'DRAWING_POLYGON',
    DRAWING_POLYLINE: 'DRAWING_POLYLINE',
    DRAWING_RECTANGLE: 'DRAWING_RECTANGLE',
    DRAWING_BOOLEAN: 'DRAWING_BOOLEAN',
    SELECTION: 'SELECTION',
    UNDO: 'UNDO',
    REDO: 'REDO',
    NONE: 'NONE'
};
export var DRAWING_STATES = {
    DRAWING: 'DRAWING',
    COMPLETE: 'COMPLETE',
    NONE: 'NONE'
};
export var DRAWING_ACTIONS = {
    DRAW: 'DRAW',
    COMPLETE: 'COMPLETE',
    STOP_DRAWING: 'STOP_DRAWING'
};
var DrawingControls = function(param) {
    var mapState = param.mapState, setMapState = param.setMapState, sendDrawingState = param.sendDrawingState, isReadOnly = param.isReadOnly;
    var _state_map, _state_map1, _state_map2, _state_map3, _state_map4, _state_map5;
    var _useContext = useContext(MapViewContext), state = _useContext.state, actions = _useContext.actions;
    var _useState = _sliced_to_array(useState(false), 2), isBooleanDisabled = _useState[0], setIsBooleanDisabled = _useState[1];
    useEffect(function() {
        if (Object.keys(state.geometries).length < 1) {
            setIsBooleanDisabled(true);
        } else {
            var disable = true;
            Object.keys(state.geometries).forEach(function(geometryId) {
                if (state.geometries[geometryId].type === 'rectangle' || state.geometries[geometryId].type === 'polygon') {
                    disable = false;
                }
            });
            setIsBooleanDisabled(disable);
        }
    }, [
        state.geometries
    ]);
    useEffect(function() {
        switch(mapState){
            case MAP_STATES.DRAWING_RECTANGLE:
                actions.setMarqueeState('block');
                actions.setIsAddressInfoVisible(false);
                actions.setPolygonState('none');
                actions.setPolylineState('none');
                actions.setActiveSelectionId(null);
                break;
            case MAP_STATES.DRAWING_POLYGON:
                actions.setMarqueeState('none');
                actions.setIsAddressInfoVisible(false);
                actions.setPolygonState('block');
                actions.setPolylineState('none');
                actions.setActiveSelectionId(null);
                break;
            case MAP_STATES.DRAWING_BOOLEAN:
                actions.setMarqueeState('none');
                actions.setIsAddressInfoVisible(false);
                actions.setPolygonState('block');
                actions.setPolylineState('none');
                break;
            case MAP_STATES.DRAWING_POLYLINE:
                actions.setMarqueeState('none');
                actions.setIsAddressInfoVisible(false);
                actions.setPolygonState('none');
                actions.setPolylineState('block');
                actions.setActiveSelectionId(null);
                break;
            default:
                actions.setMarqueeState('none');
                actions.setPolygonState('none');
                actions.setPolylineState('none');
                break;
        }
    }, [
        mapState
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        id: DRAWING_CONTROLS_ID,
        className: classnames('draw-menu', {
            disabled: isReadOnly
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: "position-relative"
    }, /*#__PURE__*/ React.createElement(OutlinedText, {
        label: text('Shapes'),
        svgProps: {
            width: '64px'
        }
    }), /*#__PURE__*/ React.createElement("div", {
        className: "draw-menu-button-group"
    }, /*#__PURE__*/ React.createElement(DrawingControlsButton, {
        state: MAP_STATES.DRAWING_POLYGON,
        mapState: mapState,
        setMapState: setMapState,
        sendDrawingState: sendDrawingState,
        icon: polygonIcon,
        tooltip: "Polygon tool",
        isSelected: mapState === MAP_STATES.DRAWING_POLYGON,
        canDraw: true,
        isDisabled: isReadOnly || ((_state_map = state.map) === null || _state_map === void 0 ? void 0 : _state_map.zoom) <= MAP_ZOOM_LEVEL_TO_HIDE_ELEMENTS
    }), /*#__PURE__*/ React.createElement(DrawingControlsButton, {
        state: MAP_STATES.DRAWING_RECTANGLE,
        mapState: mapState,
        setMapState: setMapState,
        sendDrawingState: sendDrawingState,
        icon: rectangleIcon,
        tooltip: "Rectangle tool",
        isSelected: mapState === MAP_STATES.DRAWING_RECTANGLE,
        canDraw: true,
        isDisabled: isReadOnly || ((_state_map1 = state.map) === null || _state_map1 === void 0 ? void 0 : _state_map1.zoom) <= MAP_ZOOM_LEVEL_TO_HIDE_ELEMENTS
    }), /*#__PURE__*/ React.createElement(DrawingControlsButton, {
        state: MAP_STATES.DRAWING_POLYLINE,
        mapState: mapState,
        setMapState: setMapState,
        sendDrawingState: sendDrawingState,
        icon: polylineIcon,
        tooltip: "Path tool",
        isSelected: mapState === MAP_STATES.DRAWING_POLYLINE,
        canDraw: true,
        isDisabled: isReadOnly || ((_state_map2 = state.map) === null || _state_map2 === void 0 ? void 0 : _state_map2.zoom) <= MAP_ZOOM_LEVEL_TO_HIDE_ELEMENTS
    }), /*#__PURE__*/ React.createElement(DrawingControlsButton, {
        state: MAP_STATES.DRAWING_BOOLEAN,
        mapState: mapState,
        setMapState: setMapState,
        sendDrawingState: sendDrawingState,
        icon: booleanIcon,
        tooltip: "Boolean tool",
        isSelected: mapState === MAP_STATES.DRAWING_BOOLEAN,
        isDisabled: isBooleanDisabled || isReadOnly || ((_state_map3 = state.map) === null || _state_map3 === void 0 ? void 0 : _state_map3.zoom) <= MAP_ZOOM_LEVEL_TO_HIDE_ELEMENTS,
        canDraw: true
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "position-relative"
    }, /*#__PURE__*/ React.createElement(OutlinedText, {
        label: text('Undo'),
        svgProps: {
            width: '64px'
        }
    }), /*#__PURE__*/ React.createElement("div", {
        className: "draw-menu-button-group"
    }, /*#__PURE__*/ React.createElement(DrawingControlsButton, {
        state: MAP_STATES.UNDO,
        mapState: mapState,
        setMapState: setMapState,
        sendDrawingState: sendDrawingState,
        icon: undoIcon,
        tooltip: "Undo",
        isDisabled: isReadOnly || ((_state_map4 = state.map) === null || _state_map4 === void 0 ? void 0 : _state_map4.zoom) <= MAP_ZOOM_LEVEL_TO_HIDE_ELEMENTS
    }), /*#__PURE__*/ React.createElement(DrawingControlsButton, {
        state: MAP_STATES.REDO,
        mapState: mapState,
        setMapState: setMapState,
        sendDrawingState: sendDrawingState,
        icon: redoIcon,
        tooltip: text('redo'),
        isDisabled: isReadOnly || ((_state_map5 = state.map) === null || _state_map5 === void 0 ? void 0 : _state_map5.zoom) <= MAP_ZOOM_LEVEL_TO_HIDE_ELEMENTS
    }))));
};
DrawingControls.propTypes = {
    mapState: PropTypes.string.isRequired,
    setMapState: PropTypes.func.isRequired,
    sendDrawingState: PropTypes.func.isRequired,
    isReadOnly: PropTypes.bool
};
export default DrawingControls;
